/**
 * status check response GET
 * (academic version)
 * @param response
 * @return {Promise<resolve>|Promise<reject>}
 */
const status = (response) => {
    if (response.status >= 200 && response.status < 300) { // or response.ok === true
        return Promise.resolve(response);
    } else {
        // this will handle our bad response headers
        // watch it e.cause is not fully supported on some androids (I don't care about IE anymore ;-)
        return Promise.reject(new Error("No fetch url "+ response.url +"\n\tBad response = no data ->\n\t" + response.status + ": " + response.statusText, {cause: response.status}));
    }
}
/**
 * Get one or more Entities
 * (academic version)
 * @param dataUrl
 * @return {Promise<[Object]|Object|reject>} Array of json object(s), or rejection
 */
export const fetcher = (dataUrl) => {
    try {
        console.log((new URL(dataUrl)).toString());
        return fetch((new URL(dataUrl)).toString(), {
            credentials: 'same-origin'
        }).then(status).then(response => response.json());
    } catch (e) {
        // will only fire when problem /w fetch() or json()
        return Promise.reject(new Error("fetch or json ->\n\t" + e.message + "\n\t" + e.trace), {cause: e});
    }
}
/**
 * Search for one or more Entities
 * (chained on previous version)
 * @param dataUrl
 * @param query
 * @param param
 * @return {Promise<[Object]|Object|reject>} Array of json object(s), or rejection
 */
export const searcher = (dataUrl, query='', param = 'zoek') => {
    try {
        return fetcher(dataUrl +'?'+ new URLSearchParams(''+param+'='+query));
    } catch (e) {
        return Promise.reject(new Error("problem /w fetcher (fetch/json) ->\n\t" + e.message + "\n\t" + e.trace, {cause: e}));
    }
}
/**
 * Delete an Entity
 * @param dataUrl
 * @return {Promise<boolean>} status-check of deletion (200=< <300)
 */
export const eraser = async (dataUrl) => {
    const res = await fetch((new URL(dataUrl)).toString(),{ credentials: 'same-origin', method: "delete" });
    await res.text(); // to make sure we have a response. ...
    return (res.ok) ? res.ok : Promise.reject(Error("Not deleting "+res.url+" ->\n\t" + res.status + ":\n\t" + res.statusText, {cause : res.status}));
}
/**
 * Add/update an Entity
 * @param dataUrl
 * @param formData json formatted key-value paired formData
 * @param method post|put
 * @return {Promise<string>|Promise<never>} status-check of addition (200=< <300) ? header?.location??dataUrl | reject
 */
export const alter = async (dataUrl = '', formData = {}, method = 'post') => {
    const res = await fetch((new URL(dataUrl)).toString(),
        {
            method: method,
            credentials: 'same-origin',
            headers: { 'Content-Type':'application/json;charset=utf-8' },
            // obsolete -> body: JSON.stringify(Object.fromEntries(formData))
            body: formData
        });
    await res.text(); // to make sure we have a response. ...
    return (res.ok) ? res.headers.get('location')??dataUrl : Promise.reject(new Error("No '"+method+"' for "+res.url+" ->\n\t" + res.status + ":\n\t" + res.statusText, {cause : res.status}));
};
